export default __webpack_public_path__ + "static/media/blog-img63.04a706d3.jpg";